<div id="bar" #bar class="bar{{index}} h-100 w-100">
    <p *ngIf="!barData?.length" class="mt">No Data</p>
</div>